import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useDateRangePickerStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      width: '100%',

      [theme.breakpoints.up('md')]: {
        alignItems: 'baseline',
        width: 'auto',
        flexDirection: 'row'
      }
    },

    delimeter: {
      margin: theme.spacing(0, 4),
      display: 'flex',
      alignItems: 'center'
    }
  })
)
